module.exports = __webpack_public_path__ + "static/media/medical_wallet.054e43d9.svg";